import {
	GOAL_DIRECTORY_ARCHIVED_PAGE,
	GOAL_DIRECTORY_FOLLOWING_PAGE,
	GOAL_DIRECTORY_PAGE,
	PROJECT_DIRECTORY_PAGE,
	TAGS_DIRECTORY,
	STAFF_DIRECTORY_PAGE,
	TEAM_DIRECTORY_PAGE,
	PEOPLE_DIRECTORY_PAGE,
	PROJECT_DIRECTORY_ARCHIVED_PAGE,
	PROJECT_DIRECTORY_FOLLOWING_PAGE,
} from '@townsquare/config/routes';
import { RelayResourceConfig, createRelayResource } from '@townsquare/relay-utils';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import ExplainerQuery, {
	TqlExplainerQuery,
	TqlEntity,
} from '../components/__generated__/TqlExplainerQuery.graphql';

const getEntity = (routeName: string, query?: Record<string, any>): TqlEntity | null => {
	switch (routeName) {
		// Setting goal entities for goals app directory routes
		case GOAL_DIRECTORY_FOLLOWING_PAGE:
			return 'GOAL';
		case GOAL_DIRECTORY_ARCHIVED_PAGE:
			return 'GOAL';
		// Setting project entities for project app directory routes
		case PROJECT_DIRECTORY_FOLLOWING_PAGE:
			return 'PROJECT';
		case PROJECT_DIRECTORY_ARCHIVED_PAGE:
			return 'PROJECT';
		// Setting entity for relevant directories
		case PROJECT_DIRECTORY_PAGE:
			return 'PROJECT';
		case GOAL_DIRECTORY_PAGE:
			return 'GOAL';
		case TAGS_DIRECTORY:
			return 'TAG';
		case STAFF_DIRECTORY_PAGE: {
			if (query?.screen === 'SEARCH_TEAMS') {
				return 'TEAM';
			} else if (query?.screen === 'SEARCH_PEOPLE') {
				return 'PERSON';
			}
			return null;
		}
		case TEAM_DIRECTORY_PAGE:
			return 'TEAM';
		case PEOPLE_DIRECTORY_PAGE:
			return 'PERSON';
		default:
			return null;
	}
};

export const getTqlExplainerResourceQuery = (
	routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<TqlExplainerQuery> => {
	const { workspace, collabContext } = resourceContext as ResourceContext;
	const entity = getEntity(routerContext.route.name, routerContext.query);
	const { tql, viewUuid } = routerContext.query;
	const hasTqlOrViewUuidAndEntity = (!!tql || !!viewUuid) && !!entity;

	return {
		query: ExplainerQuery,
		variables: {
			entity,
			tql,
			directoryViewUuid: viewUuid,
			workspaceUuid: workspace?.UUID,
			containerId: collabContext?.contextId,
			hasTqlOrViewUuidAndEntity,
		},
		options: {
			fetchPolicy: 'store-and-network',
		},
	};
};

export const tqlExplainerResource = createRelayResource<TqlExplainerQuery>({
	getQuery: getTqlExplainerResourceQuery,
});
